import { render, staticRenderFns } from "./business.vue?vue&type=template&id=4983edc1&scoped=true"
import script from "./business.vue?vue&type=script&lang=js"
export * from "./business.vue?vue&type=script&lang=js"
import style0 from "./business.vue?vue&type=style&index=0&id=4983edc1&prod&lang=css"
import style1 from "./business.vue?vue&type=style&index=1&id=4983edc1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4983edc1",
  null
  
)

export default component.exports